import { registerSW } from 'virtual:pwa-register';

if ('serviceWorker' in navigator) {
    const updateSW = registerSW({
        immediate: true,

        onRegisteredSW(_swUrl, registration) {
            if (!registration) return;

            // Check for updates every 5 minutes
            setInterval(
                () => {
                    registration.update();
                },
                120 * 60 * 1000,
            );

            // Also check when tab becomes visible
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    registration.update();
                }
            });
        },

        // Immediately activate new version
        onNeedRefresh() {
            updateSW(true);
        },
    });
}
